import * as React from 'react';

import LearningPathBreadcrumbTrail from 'bundles/enterprise-learning-path-description-page/modules/LearningPathBreadcrumbTrail';

type Props = {
  programSlug: string;
};

const LearningPathBreadcrumbs = ({ programSlug }: Props) => {
  return <LearningPathBreadcrumbTrail programSlug={programSlug} />;
};

export default LearningPathBreadcrumbs;
